/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// This is a private, forked component. No need to test
// @flow

import * as React from 'react';
import styles from './Backdrop.less';

/**
 * A backdrop specifically for SocialFab. Opening the FAB has multiple layers to it, and it's easier to fork the component than to play around with the overlay Backdrop
 *
 */
type Props = {|
  onClick?: (event: SyntheticEvent<*>) => mixed,
|};

const Backdrop = (props: Props) => <div className={styles.backdrop} onClick={props.onClick} />;

Backdrop.defaultProps = {
  onClick: undefined,
};

export default Backdrop;
